import { useQuery, UseQueryResult } from 'react-query'

import { homeQueries } from 'features/projects/queries'
import { HomeService } from 'features/projects/service'

export const useProjectMeta = (service: HomeService): UseQueryResult =>
  useQuery(homeQueries.projectMeta(service))
